import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../Store/Reducers';
import { Prompt, UserSettings } from '../Types';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import requestClient from '../components/Utility/RequestClient';

const useGlobals = () => {
    const userSettings = useSelector((state: RootState) => state.userSettings as UserSettings);
    const i18n = useSelector((state: RootState) => state.i18n.i18n);
    const navigate = useNavigate() as NavigateFunction;
    const settings = useSelector((state: RootState) => state.settings);
    const demo = useSelector((state: RootState) => state.environment.demoInstance as boolean);
    const windowWidth = useSelector((state: RootState) => state.environment.windowWidth);
    const dispatch = useDispatch();
    const themes = useSelector((state: any) => state.themes.allThemes);
    const selectedTheme = useSelector((state: any) => state.themes.selectedTheme);
    const isCtrlOrCmdPressed = useSelector((state: RootState) => state.environment.isCtrlOrCmdPressed);
    const currentURL = useSelector((state: RootState) => state.environment.currentURL);
    const currentChatId = useSelector((state: RootState) => state.environment.currentChatId);
    const prompts = useSelector((state: RootState) => state.chats.prompts);
    const sourceContainerOpen = useSelector((state: RootState) => state.messageSource.isOpen);

    const getPrompt = useCallback(
        (identifier: string) => {
            return prompts.find((prompt: any) => prompt.identifier === identifier) as Prompt;
        },
        [prompts],
    );

    const getBreakpoint = useCallback((breakpoint: string): number => {
        const variableName = `--breakpoint-${breakpoint}`;
        const value = getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
        const numericValue = parseInt(value, 10);

        if (isNaN(numericValue)) {
            return 768; //default value md
        }

        return numericValue;
    }, []);

    const handleNavigate = useCallback(
        (path: string) => {
            navigate(path);
        },
        [navigate],
    );

    return useMemo(
        () => ({
            handleNavigate,
            userSettings,
            i18n,
            settings,
            demo,
            windowWidth,
            getBreakpoint,
            requestClient,
            dispatch,
            themes,
            selectedTheme,
            isCtrlOrCmdPressed,
            currentURL,
            currentChatId,
            getPrompt,
            prompts,
            sourceContainerOpen,
        }),
        [
            handleNavigate,
            userSettings,
            i18n,
            settings,
            demo,
            windowWidth,
            getBreakpoint,
            dispatch,
            themes,
            selectedTheme,
            isCtrlOrCmdPressed,
            currentURL,
            currentChatId,
            getPrompt,
            prompts,
            sourceContainerOpen,
        ],
    );
};

export default useGlobals;
